import { render, staticRenderFns } from "./QuestionMarkIcon.vue?vue&type=template&id=51e9f3ae&"
var script = {}


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/packages/axiom-design-system/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('51e9f3ae')) {
      api.createRecord('51e9f3ae', component.options)
    } else {
      api.reload('51e9f3ae', component.options)
    }
    module.hot.accept("./QuestionMarkIcon.vue?vue&type=template&id=51e9f3ae&", function () {
      api.rerender('51e9f3ae', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/04-web-components/navbar/icons/QuestionMarkIcon.vue"
export default component.exports